import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import messages from '../../utils/translationMessages';
import { VIDEO_TOUR_OPEN_EVENT } from '../../constants/dataLayer';

import './style.css';

class LiveVideoTour extends PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (window.digitalDataBuilder && window.digitalDataBuilder.addLead) {
      const { listingId } = this.props;
      window.digitalDataBuilder.addLead(listingId, VIDEO_TOUR_OPEN_EVENT);
    }
    this.props.openVideoTourModal();
  }

  render() {
    const { intl: { formatMessage } } = this.props;
    return <div className="live-video-tour" onClick={this.onClick}>
      {formatMessage(messages.liveVideoTour)}
    </div>;
  }
}

LiveVideoTour.propTypes = {
  listingId: PropTypes.number.isRequired,
  openVideoTourModal: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired
};

export default (injectIntl(LiveVideoTour));
